var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindInPage(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m633.347-145.087 79.783 79.218H225.087q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-669.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h373.131l216.478 247.478V-154q0 16.826-9.761 33.87-9.761 17.043-24.717 28.87L565.306-306.652q-19.915 12.565-39.803 17.283-19.889 4.717-45.503 4.717-65.391 0-109.87-44.213Q325.652-373.079 325.652-439q0-65.391 44.478-110.152 44.479-44.761 109.87-44.761t110.152 44.761Q634.913-504.391 634.913-439q0 26.391-6.782 47.391-6.783 21-19.218 37l126 124.869v-392.198L568-814.913H225.087v669.826h408.26ZM480-357.087q35.739 0 58.826-27.709 23.087-27.71 23.087-65.109 0-31.399-24.587-51.204-24.587-19.804-57.326-19.804-32.739 0-57.326 19.709-24.587 19.71-24.587 51.109 0 37.399 23.087 65.204 23.087 27.804 58.826 27.804ZM480-450Zm0 0Z"
  })));
}
export default SvgFindInPage;